import * as types from '@/store/types';
import ProfileService from '@/services/ProfileService';
import LocationService from '@/services/core/LocationService';
import AvatarService from '@/services/AvatarService';

export default {
  async fetch({ commit }) {
    try {
      const { data: { data } } = await ProfileService.fetch();
      commit(types.FETCH_PROFILE_SUCCESS, data);
    } catch (e) {
      commit(types.FETCH_PROFILE_FAILURE);
    }
  },

  async update({ commit }, profile) {
    try {
      const { data: { data } } = await ProfileService.update(profile, true);
      commit(types.FETCH_PROFILE_SUCCESS, data);
    } catch (e) {
      commit(types.FETCH_PROFILE_FAILURE);
    }
  },

  setAddress({ commit }, address) {
    LocationService.setAddress(address);
    commit(types.SET_ADDRESS, address);
  },

  setLocation({ commit }, location) {
    LocationService.setLocation(location);
    commit(types.SET_LOCATION, location);
  },

  async fetchAvatars({ commit }) {
    try {
      const { data: { data } } = await AvatarService.fetch();
      commit(types.FETCH_AVATARS_SUCCESS, data);
    } catch (e) {
      commit(types.FETCH_AVATARS_FAILURE);
    }
  },
};
